import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Country } from 'src/app/models/country.model';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { QuoteService } from 'src/app/service/quote.service';
import { AddressModel, GetQuoteResponseModel, MemberModel, PhoneModel } from 'src/app/service/web-api-client';
import { SelectItemModel } from 'src/app/models/select-item';

@Component({
  selector: 'app-quote-step9-desktop',
  templateUrl: './quote-step9-desktop.component.html',
  styleUrls: ['./quote-step9-desktop.component.css']
})
export class QuoteStep9DesktopComponent implements OnInit {
    towerNew: string = '/assets/external/tower-new-resize.png'
    ballPink1srcNew: string = '/assets/external/newbasketball-resize.png'
  vectorUnFilled: string = '/assets/external/vector3387-ovts.svg'
  vectorfilled: string = '/assets/external/vector3387-ynbm.svg'
  @Input()
  ellipse25src1: string = '/assets/external//ellipse253402-hag.svg'
  @Input()
  vectoralt15: string = 'VectorI3402'
  @Input()
  inputplaceholder9: string = '114040276'
  @Input()
  ellipse25src4: string = '/assets/external//ellipse253402-9uei.svg'
  @Input()
  vectoralt4: string = 'Vector3402'
  @Input()
  ellipse25src3: string = '/assets/external//ellipse253402-rpbr.svg'
  @Input()
  vectoralt2: string = 'Vector3402'
  @Input()
  vectorsrc9: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/8ef067f3-4340-4cac-8980-42814b81678a?org_if_sml=1633&force_format=original'
  @Input()
  vectoralt3: string = 'Vector3402'
  @Input()
  inputplaceholder8: string = '114040276'
  @Input()
  vectorsrc15: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/e8e6edac-f686-4774-b201-7c7bb40aef8e?org_if_sml=1490&force_format=original'
  @Input()
  ellipse25alt3: string = 'Ellipse253402'
  @Input()
  vectorsrc6: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/e5134d82-f312-4d2e-88f1-e543ba4e1166?org_if_sml=1624&force_format=original'
  @Input()
  vectorsrc7: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/6ff1d2ef-0dd9-4ffa-a5c6-bb551b2d2be9?org_if_sml=1171&force_format=original'
  @Input()
  vectoralt5: string = 'VectorI3402'
  @Input()
  inputplaceholder: string = 'Andrea'
  @Input()
  rootClassName: string = ''
  @Input()
  vectorsrc1: string = '/assets/external//vector3402-09or.svg'
  @Input()
  ellipse25src2: string = '/assets/external//ellipse253402-lwx6.svg'
  @Input()
  ellipse25src: string = '/assets/external//ellipse253402-zbbh.svg'
  @Input()
  vectorsrc5: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/849f8611-ed8a-4f74-aa1f-995df3fd11a6?org_if_sml=11330&force_format=original'
  @Input()
  ellipse25alt4: string = 'Ellipse253402'
  @Input()
  vectoralt11: string = 'VectorI3402'
  @Input()
  ellipse25alt: string = 'Ellipse253402'
  @Input()
  vectorsrc8: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/c639c84b-167a-466a-8ec8-68c35252da77?org_if_sml=1503&force_format=original'
  @Input()
  inputplaceholder2: string = 'Andrea'
  @Input()
  vectorsrc14: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/edfb1599-156b-441e-a1c1-328814f80851?org_if_sml=1740&force_format=original'
  @Input()
  vectoralt10: string = 'VectorI3402'
  @Input()
  inputplaceholder6: string = '114040276'
  @Input()
  vectorsrc: string = '/assets/external//vector3402-42.svg'
  @Input()
  inputplaceholder10: string = 'Costa Rica'
  @Input()
  inputplaceholder5: string = '+506 | 88118380'
  @Input()
  inputplaceholder3: string = 'Aam09@gmail.com'
  @Input()
  vectorsrc11: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/7a5b7f03-2bac-4d9f-9739-3f0257bc5a65?org_if_sml=1744&force_format=original'
  @Input()
  vectorsrc2: string = '/assets/external//vector3402-9vxp.svg'
  @Input()
  vectoralt12: string = 'VectorI3402'
  @Input()
  vectoralt9: string = 'VectorI3402'
  @Input()
  vectoralt6: string = 'VectorI3402'
  @Input()
  inputplaceholder7: string = 'Costa Rica'
  @Input()
  ellipse25alt2: string = 'Ellipse253402'
  @Input()
  vectoralt14: string = 'VectorI3402'
  @Input()
  vectorsrc10: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/00756062-4aa6-44cf-a085-77d7c0f9d626?org_if_sml=1517&force_format=original'
  @Input()
  ellipse25alt1: string = 'Ellipse253402'
  @Input()
  vectorsrc13: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/3cef57fe-9a2b-4c10-bcc9-318e79e4a490?org_if_sml=1222&force_format=original'
  @Input()
  vectoralt7: string = 'VectorI3402'
  @Input()
  inputplaceholder4: string = '+506 | 88118380'
  @Input()
  inputplaceholder1: string = 'Amador Montoya'
  @Input()
  vectorsrc12: string =
    'https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/3d4a8b38-23a4-4c0d-916f-173c88c76ea4/05e91862-b7fe-4559-b99d-e5574cc49dde?org_if_sml=1743&force_format=original'
  @Input()
  vectoralt8: string = 'VectorI3402'
  @Input()
  vectorsrc4: string = '/assets/external//vector3402-rpya.svg'
  @Input()
  vectoralt1: string = 'Vector3402'
  @Input()
  vectorsrc3: string = '/assets/external//vector3402-u05a.svg'
  @Input()
  vectoralt13: string = 'VectorI3402'
  @Input()
  inputplaceholder11: string = 'Costa Rica'
  @Input()
  vectoralt: string = 'Vector3402'
  raw7pyg: string = ' '
  raw3jef: string = ' '

  @Input() screenWidth: number;
  @Input() currentStep: number;
  @Output() onNextStep: EventEmitter<number> = new EventEmitter();
  @Output() onPrevStep: EventEmitter<number> = new EventEmitter();

  stepNineForm: FormGroup;
  submitted = false;
  countriesCode: Country[] = [];
  countries: SelectItemModel[];

  selectedCountry: Country | null;
  filterValue: string = '';
  lastYear: number = new Date().getFullYear()


  constructor(private quoteService: QuoteService, private http: HttpClient, private fb: FormBuilder,) {

    this.createForm()


  }
  createForm() {
    const self = this;
    this.quoteService.getCountries$().subscribe(allCountries => {

      self.countries = allCountries.map(value => {
        let item: SelectItemModel = {
          id: value.id,
          text: value.name,
          value: value
        };
        return item;
      })
    });

    this.http.get<Country[]>('/assets/countrycode/CountryCodes.json').subscribe(data => {

      self.countriesCode = data.map(country => {
        return {
          name: country.name,
          code: country.code,
          phoneCode: country.phoneCode,
          flag: country.flag,
          id: country.phoneCode,
          text: country.name
        };
      });
    });
    this.stepNineForm = this.fb.group({
      dayNacimiento: [null, [Validators.required, Validators.min(1), Validators.max(31), Validators.pattern(/^[0-9]*$/) ]],
			mesNacimiento: [null, [Validators.required, Validators.min(1), Validators.max(12), Validators.pattern(/^[0-9]*$/) ]],
			yearNacimiento: [null, [Validators.required, Validators.min(1900), Validators.max(this.lastYear), Validators.pattern(/^[0-9]*$/) ]],
      primerNombre: ['', Validators.required],
      apellidosDelTitular: ['', Validators.required],
      pasaporteNoCédula: ['', Validators.required],
      pais: ['', Validators.required],
      phoneCode: [''],
      telefonoFijo: [''],
      telefonoMovil: [''],
      direccionDeResidencia: ['', Validators.required],
      ciudad: ['', Validators.required],
      estado: ['', Validators.required],
      codigoPostal: ['', Validators.required],
    });

  }
  formatTwoDigits(number) {
    return number.toString().padStart(2, '0');
  }

  private getMemberKey(member: MemberModel): string {
    if (member?.memberId && member.memberId > 0) {
      return `id-${member.memberId}`;
    }
    const firstName = (member?.firstName || '').trim().toLowerCase();
    const lastName = (member?.lastName || '').trim().toLowerCase();
    const passportNumber = (member?.passportNumber || '').trim().toLowerCase();
    const birthdate = (member?.birthdate || '').trim();
    return `temp-${firstName}-${lastName}-${passportNumber}-${birthdate}`;
  }

  private getMemberType(member: MemberModel): number {
    if (!member) {
      return 0;
    }
    return member.memberTypeId || member.memberType?.id || 0;
  }

  private assignMemberType(member: MemberModel, memberTypeId: number, isDependent: boolean): void {
    if (!member) {
      return;
    }
    member.memberTypeId = memberTypeId;
    if (member.memberType) {
      member.memberType.id = memberTypeId;
    }
    member.isDependent = isDependent;
  }

  private sanitizeMember(member: MemberModel): MemberModel {
    if (!member) {
      return member;
    }

    const sanitized = new MemberModel(member);
    sanitized.phones = (sanitized.phones || [])
      .map(phone => new PhoneModel(phone))
      .map(phone => {
        const typeId = phone.phoneTypeId || phone.phoneType?.id || 0;
        phone.phoneTypeId = typeId;
        if (phone.phoneType) {
          phone.phoneType.id = typeId;
        }
        return phone;
      })
      .filter(phone => phone.phoneTypeId === 1 || phone.phoneTypeId === 2);

    return sanitized;
  }

  private upsertMember(updatedMember: MemberModel): MemberModel[] {
    const members = [...(this.quoteService.quoteModel?.members || [])].map(member => this.sanitizeMember(member));
    const sanitizedMember = this.sanitizeMember(updatedMember);
    const updatedType = this.getMemberType(sanitizedMember);
    const updatedMemberId = sanitizedMember?.memberId;
    this.assignMemberType(sanitizedMember, updatedType, updatedType === 2);

    const filteredMembers = members.filter(existingMember => {
      if (!existingMember) {
        return false;
      }
      if (updatedMemberId && updatedMemberId > 0) {
        return existingMember.memberId !== updatedMemberId;
      }
      if (updatedType === 1) {
        return this.getMemberType(existingMember) !== 1;
      }
      if (!updatedMemberId && !existingMember.memberId && this.getMemberType(existingMember) === updatedType) {
        const sameIdentity =
          existingMember.firstName === updatedMember.firstName &&
          existingMember.lastName === updatedMember.lastName &&
          existingMember.passportNumber === updatedMember.passportNumber &&
          existingMember.birthdate === updatedMember.birthdate;
        return !sameIdentity;
      }
      return true;
    });

    filteredMembers.push(sanitizedMember);
    return this.sortMembers(filteredMembers);
  }

  private mergeMembers(existingMembers: MemberModel[], apiMembers: MemberModel[]): MemberModel[] {
    const memberMap = new Map<string, MemberModel>();

    const addOrUpdate = (member: MemberModel, isApiMember = false) => {
      if (!member) {
        return;
      }
      const normalizedMember = this.sanitizeMember(member);
      const memberType = this.getMemberType(normalizedMember);
      if (memberType > 0) {
        normalizedMember.memberTypeId = memberType;
      }
      const key = this.getMemberKey(normalizedMember);
      if (!memberMap.has(key) || isApiMember) {
        memberMap.set(key, normalizedMember);
      }
    };

    (existingMembers || []).forEach(member => addOrUpdate(member));
    (apiMembers || []).forEach(member => addOrUpdate(member, true));

    return this.sortMembers(Array.from(memberMap.values()));
  }

  private sortMembers(members: MemberModel[]): MemberModel[] {
    const priorityMap: Record<number, number> = {
      1: 0,
      2: 1,
      3: 2
    };

    return members
      .filter(member => !!member)
      .sort((memberA, memberB) => {
        const weightA = priorityMap[this.getMemberType(memberA)] ?? 99;
        const weightB = priorityMap[this.getMemberType(memberB)] ?? 99;

        if (weightA !== weightB) {
          return weightA - weightB;
        }

        const memberIdA = memberA.memberId ?? Number.MAX_SAFE_INTEGER;
        const memberIdB = memberB.memberId ?? Number.MAX_SAFE_INTEGER;
        return memberIdA - memberIdB;
      });
  }

  nextStep(): void {
    this.submitted = true;

    if (this.stepNineForm.valid) {

      const self = this;
      const formValues = this.stepNineForm.value
      console.log('formValues', formValues);
      const existingMembers = this.quoteService.quoteModel?.members || [];
      let member = existingMembers.find(currentMember => this.getMemberType(currentMember) === 1) || new MemberModel({
        memberTypeId: 1,
        memberId: 0,
        phones: []
      });
      member.firstName = formValues.primerNombre;
      member.lastName = formValues.apellidosDelTitular;
      member.passportNumber = formValues.pasaporteNoCédula;
      member.countryId = formValues.pais;
      member.memberTypeId = 1;
      this.assignMemberType(member, 1, false);
      member.birthdate = `${formValues.yearNacimiento}-${this.formatTwoDigits(formValues.mesNacimiento)}-${this.formatTwoDigits(formValues.dayNacimiento)}`;
      member.address = new AddressModel({
        address1: formValues.direccionDeResidencia,
        state: formValues.estado,
        city: formValues.ciudad,
        postalCode: formValues.codigoPostal
      });
      member.phones = [];
      if(formValues.telefonoFijo){
        member.phones.push(new PhoneModel({
          countryCode: formValues.phoneCode,
          phoneNumber: formValues.telefonoFijo,
          phoneTypeId: 1   
        }))
      }

      if(formValues.telefonoMovil){
        member.phones.push(new PhoneModel({
          countryCode: formValues.phoneCode,
          phoneNumber: formValues.telefonoMovil,
          phoneTypeId: 2
        }))
      }
       
      this.quoteService.quoteModel.members = this.upsertMember(member);
      const membersToPersist = [...this.quoteService.quoteModel.members];
      const result = this.quoteService.updateCertificate$(this.quoteService.quoteModel).subscribe(r => {
        const resultJson = JSON.stringify(r);
        const result = JSON.parse(resultJson);
        try {
          console.log('resultresult', result);
          const mergedMembers = this.mergeMembers(membersToPersist, result.members);
          self.quoteService.quoteModel = result;
          self.quoteService.quoteModel.members = mergedMembers;
          console.log(self.quoteService.quoteModel);
          if(self.quoteService.quoteModel.dependentCount === 0 && self.quoteService.quoteModel.dependentCountOver65 === null ) {
            console.log('self.currentStep + 1', self.currentStep  );
            self.onNextStep.emit(11);
          } else {
            self.onNextStep.emit(self.currentStep);
          }
        } catch (error) {
          console.log('error', error);
        }
        return result;
      });
      console.log('resultresultresult', result)
    }


  }

  prevStep(): void {
    this.onPrevStep.emit(this.currentStep);
  }

  ngOnInit() {

    if (this.quoteService.quoteModel) {
      if (this.quoteService.quoteModel && this.quoteService.quoteModel.members && this.quoteService.quoteModel.members.length > 0) {
        const getOwner = this.quoteService.quoteModel.members.find(member => this.getMemberType(member) === 1);
        if (getOwner) {
          const birthDate = new Date(getOwner.birthdate);
          this.stepNineForm.controls.primerNombre.setValue(getOwner.firstName);
          this.stepNineForm.controls.apellidosDelTitular.setValue(getOwner.lastName);
          this.stepNineForm.controls.pasaporteNoCédula.setValue(getOwner.passportNumber);
          this.stepNineForm.controls.dayNacimiento.setValue(this.formatTwoDigits(birthDate.getDate()));
          this.stepNineForm.controls.mesNacimiento.setValue(this.formatTwoDigits(birthDate.getMonth() + 1));
          this.stepNineForm.controls.yearNacimiento.setValue(this.formatTwoDigits(birthDate.getFullYear()));

          const country = getOwner?.countryId || getOwner?.country?.id || null;

          const self = this;
          if (country) {
            setTimeout(() => {
              console.log('country', country, getOwner?.country);
              self.stepNineForm.controls.pais.setValue(country);
            }, 1500)

          }
          const telefonoMovil = getOwner.phones.filter(phone => phone.phoneTypeId === 2 || phone.phoneType.id === 2)[0] || null;
          console.log('telefonoMovil', telefonoMovil);
          if (telefonoMovil) {
            console.log('telefonoMovil', telefonoMovil);
            this.stepNineForm.controls.phoneCode.setValue(telefonoMovil.countryCode);
            this.stepNineForm.controls.telefonoMovil.setValue(telefonoMovil.phoneNumber);
          }
          const telefonoFijo = getOwner.phones.filter(phone => phone.phoneTypeId === 1 || phone.phoneType.id === 1)[0] || null;
          console.log('telefonoFijo', telefonoFijo);
          if (telefonoFijo) {

            this.stepNineForm.controls.phoneCode.setValue(telefonoFijo.countryCode);
            this.stepNineForm.controls.telefonoFijo.setValue(telefonoFijo.phoneNumber);
          }
          if (getOwner.address) {
            this.stepNineForm.controls.direccionDeResidencia.setValue(getOwner.address.address1 || '');
            this.stepNineForm.controls.ciudad.setValue(getOwner.address.city || '');
            this.stepNineForm.controls.estado.setValue(getOwner.address.state || '');
            this.stepNineForm.controls.codigoPostal.setValue(getOwner.address.postalCode || '');
          }

        }
      }
    }
  }

}
